module.exports = __webpack_public_path__ + "static/media/background-book.90da4b30.jpg";